export default __webpack_public_path__ + "static/media/dyndns.1978b917.svg";